module.exports = __webpack_public_path__ + "img/TZ.b369e088.svg";